<template>
  <transition name="fade">
    <button 
      v-if="isVisible" 
      class="scroll-to-top" 
      @click="scrollToTop"
      aria-label="Scroll to top"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="icon">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
      </svg>
    </button>
  </transition>
</template>

<script>
export default {
  name: 'ScrollToTop',
  data() {
    return {
      isVisible: false,
      containerRef: null
    };
  },
  mounted() {
    // Find the main scrollable container
    this.containerRef = document.querySelector('.container');
    if (this.containerRef) {
      this.containerRef.addEventListener('scroll', this.checkVisibility);
    } 
    // Also listen to window in case the layout changes or on mobile
    window.addEventListener('scroll', this.checkVisibility);
  },
  beforeUnmount() {
    if (this.containerRef) {
      this.containerRef.removeEventListener('scroll', this.checkVisibility);
    }
    window.removeEventListener('scroll', this.checkVisibility);
  },
  methods: {
    checkVisibility() {
      // Check both window and container
      const containerScroll = this.containerRef ? this.containerRef.scrollTop : 0;
      const windowScroll = window.scrollY;
      this.isVisible = containerScroll > 300 || windowScroll > 300;
    },
    scrollToTop() {
      if (this.containerRef) {
        this.containerRef.scrollTo({ top: 0, behavior: 'smooth' });
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>

<style scoped>
.scroll-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #18181b;
  border: 1px solid #00dc82;
  color: #00dc82;
  width: 48px;
  height: 48px;
  border-radius: 4px; /* Sharp corners */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000;
  transition: all 0.2s ease;
  box-shadow: 0 4px 0 #006b3f; /* Blocky shadow */
}

.scroll-to-top:hover {
  background: #00dc82;
  color: #000000;
  transform: translateY(-2px);
  box-shadow: 0 6px 0 #004d2d;
}

.scroll-to-top:active {
  transform: translateY(0);
  box-shadow: 0 0 0 transparent;
}

.icon {
  width: 24px;
  height: 24px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
